export default __webpack_public_path__ + "static/media/AODG26844.87d90ee1.png";